module.exports = __webpack_public_path__ + "img/auth1.477505d7.png";